import api from "../instance/axios_instance.ts";
const CustomerGroupApi = async (): Promise<any> => {

    try {
        const response = await api.get('/customer_group', { skipAuth: true } as any);
        return response.data;
    } catch (error) {
        const mensajeError = error.response?.data?.message;
        throw new Error(mensajeError || 'Error credito');
    }
};

export default CustomerGroupApi;